<template>
  <BaseFinancialStatementSnapshot docType="INCOME" />
</template>

<script>
import BaseFinancialStatementSnapshot from '@/component/BaseFinancialStatementSnapshot.vue'

export default {
  name: 'IncomeList',
  components: { BaseFinancialStatementSnapshot },
}
</script>
